module.exports = __webpack_public_path__ + "img/logo-roma.41b83d6b.png";